export default {
  setUser(state, payload) {
    state.token = payload.token;
    state.currentUser = payload.currentUser;
    state.didAutoLogout = false;
    //console.log('setUser에서 제대로 나오는지'+ payload.currentUser.nic);
  },
  setAutoLogout(state) {
    state.didAutoLogout = true;
  },
  setGuestUser(state, payload){
    state.token = payload.token;
    state.currentUser = payload.currentUser;
      //console.log('setGuestUser 제대로 나오는지'+ payload.currentUser.nic);
  },
  setUserIP(state, payload){
    state.userIP = payload.userIP;
  },
  updateUserPoint(state, payload)
  {
    //유저 정보 통으로 갱신
    state.currentUser = payload
    //state.currentUser.point = state.currentUser.point + payload.point; 
    //state.currentUser.level = payload.level; 
  }
};
